import {
  makeStyles,
  Container,
  useMediaQuery,
  useTheme,
} from '@material-ui/core'
import CarouselSp2 from '../ui/CarouselSp2'

import dynamic from 'next/dynamic'
import { useTranslation } from 'next-i18next'
const CouriersDesktop = dynamic(() => import('./CouriersDesktop'))

const useStyles = makeStyles((theme) => ({
  root: {
    ...theme.homeStyle.root,
    backgroundColor: '#fafafa',
    padding: theme.homeStyle.sectionPadding,
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  courierSlide: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  courierImg: {
    maxHeight: '70px',
    maxWidth: '180px',
    margin: `${theme.spacing(4)}px ${theme.spacing(2)}px`,
  },
  title: {
    ...theme.homeStyle.title,
  },
}))

const CourierSlide = ({ classes, img1, img2 }) => (
  <div className={classes.courierSlide}>
    <img src={`${img1}`} alt="" className={classes.courierImg} />
    {img2 && <img src={`${img2}`} alt="" className={classes.courierImg} />}
  </div>
)

const Couriers = ({ couriers = [[]] }) => {
  const theme = useTheme()
  const isTabletOrMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'))

  const classes = useStyles()

  const { t } = useTranslation('common')
  // console.info(`x`)
  return (
    <div className={classes.root}>
      <Container>
        <h1 className={classes.title}>{t('couriers.title')}</h1>
      </Container>
      {Array.isArray(couriers) && Array.isArray(couriers[0]) ? (
        <>
          {isTabletOrMobile ? (
            <CarouselSp2
              slidesPerPage={isTablet ? 3 : 1.6}
              showDots
              autoPlay
              denseDots
            >
              {couriers.map(([img1, img2]) => (
                <CourierSlide
                  img1={img1}
                  img2={img2}
                  classes={classes}
                  key={img1}
                />
              ))}
            </CarouselSp2>
          ) : (
            <Container>
              <CouriersDesktop couriers={couriers} />
            </Container>
          )}
        </>
      ) : (
        <p>{t('fetch-error')}</p>
      )}
    </div>
  )
}

export default Couriers
